import * as dc from "@/components/layout/list/defaultType";
import { DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { brewingDefault, brewingInit } from "../../inputCols/brewingCols";
import { brewingClipboard } from "../../inputCols/clipboard";
import { enLocale } from "@/i18n/routing";
export const UserBrewing = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;
  let readOnlyMode = false;

  switch (params?.page.page ?? "") {
    //추출기본설정
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_default","system_table_pk":["cafe_seq","brewing_seq"],"system_table_manual_increment":"brewing_seq","system_table_page":"UserBrewingDefault","system_table_path":"api/user/brewing/default","system_table_page_name":"UserBrewingDefault","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["brewing_type","brewing_public"],"system_table_search_select":["brewing_name_locale","brewing_name"],"system_table_order_column":["brewing_type"],"system_table_default_name_column":"brewing_name_locale","system_table_en_name_column":"brewing_name","system_table_use_column":"brewing_use"}
    //--info--}

    //추출단계
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_default_step","system_table_pk":["cafe_seq","brewing_seq"],"system_table_page":"UserBrewingDefaultStep","system_table_path":"api/user/brewing/defaultstep","system_table_page_name":"UserBrewingDefaultStep","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result"}
    //--info--}

    case "UserBrewingDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/user/brewing/default/detail/",
          saveFetch: { fetchUrl: "/api/user/brewing/default/edit" },
        },
        listFetch: { fetchUrl: "/api/user/brewing/default/list" },
        dataResultName: "detail_result",
        dataMerge: "detail_result_step",
        dataName: "UserBrewingDefaultData",
        editReload: true,
        clipboard: brewingClipboard,
        dataInit: (data: any) => brewingInit(form?.current, formFunction?.current, dataFunction?.current, data, params?.setTimer),
        dataCols: {
          brewing_name_guide: { ...dc.guideDefault, fixedValue: "brewing_name_guide", read: { display: false }, order: 0 },
          brewing_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: params?.locale !== enLocale ? dc.strongLabelClassName : undefined,
            required: params?.locale !== enLocale ? true : undefined,
            read: { variant: "borderless" },
            order: params?.locale !== enLocale ? 1 : 2,
          },
          brewing_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: params?.locale === enLocale ? dc.strongLabelClassName : undefined,
            required: params?.locale === enLocale ? true : undefined,
            read: { variant: "borderless" },
            order: params?.locale === enLocale ? 1 : 2,
          },

          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "user",
            "default",
            true,
          ),

          public_type: { ...dc.publicType },
          public_uuid: { ...dc.publicUUID("/info/brewing/user/") },
          brewing_use: { ...dc.useDefault },
          rgst_by: { ...dc.rgst },
          edit_by: { ...dc.edit },
        },
        listColLinkField: "brewing_seq",
        listColDesc: dc.brewingSummary(params?.locale),
        listSearch: [
          { ...dc.select, field: "search0", codeGroup: "EXTR", label: "brewing_type", placeholder: "brewing_type" },
          // {
          //   ...dc.listSearchUse,
          //   field: "search1",
          //   label: "brewing_public",
          //   placeholder: "brewing_public",
          // },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type0", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type1", label: "brewing_name", placeholder: "brewing_name" },
        ],
        listOrder: ["brewing_type_orderasc", "brewing_type_orderdesc"],
        listCols: [
          // "cafe_seq",
          // "brewing_seq",
          { field: "brewing_type", codeGroup: "EXTR" },
          params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
          {
            field: "brewing_grinder_point",
            scale: 100,
            fieldId: {
              brewing_grinder_point: { scale: 100 },
              brewing_grinder_zeropoint: {
                scale: 100,
                // prev: { element: "(", transition: false },
                // next: { element: ")", transition: false },
              },
            },
            valueJoin: " / ",
          },
          {
            field: "brewing_bean_mass",
            label: "brewing_info",
            fieldId: {
              brewing_bean_mass: { ...dc.mass },
              brewing_mass: { ...dc.mass },
              brewing_term: { ...dc.secondTimer(params?.locale) },
            },
            valueJoin: " / ",
          },

          // { field: "brewing_grinder_point", scale: 100 },
          // { field: "brewing_bean_mass", ...dc.mass },
          // { field: "brewing_mass", ...dc.mass },
          { field: "public_type", codeGroup: "PBTP" },
        ],
        listColMobileTitle: params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
        // mobileHidden: ["brewing_type", "brewing_public"],
      };
    default:
      return undefined;
  }
};
